import React from "react"
import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import { MenuCredito } from 'components/menuCredito'
import {Link} from 'react-router-dom'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

export function CuponVip(){

    return(
        <>
            <Header type="complete"/>
            <main>
                <section className="sectionPrincipal">
                    <MenuCredito />

                    <div className="contenidoLandings">
                        <h1>Cupón VIP</h1>
                        <div>
                            <p className="strong">En agradecimiento a su preferencia y el extraordinario manejo de su tarjeta de crédito Sears, le obsequiamos un 10% de descuento adicional a cualquier promoción vigente durante su próximo día de compras, presentando el cupón emitido en la registradora al realizar el pago a la tarjeta.</p>
                            <p className="strong">Este beneficio se otorga a los tarjetahabientes con un impecable historial y que utilicen constantemente su tarjeta dentro de las tiendas Sears. Está limitado a la emisión de 2 cupones al mes. </p>
                            <p><span className="underline">Excepciones</span>: Perfumería, Computación, Motocicletas, Tabletas, Tarjetas de Prepago, Tarjetas telefónicas, Telefonía celular, Juegos Electrónicos, Audio Portátil, Pantallas y Blu-Rays, Tarjetas iTunes y Concesiones.</p>
                            <p>No participan las marcas: Area Code, Baby Liss, Benetton, Beurer, Braun, Calvin Klein, Chaps, Dockers, Gracco, Innova, Leonisa, Levi´s, Marcas de Renombre, Oscar Hackman, Philosophy jr., Philosophy Plus, Philosophy Nights, Prinsel, Ted Kenton, Tommy Hilfiger, Vitos y Quinny, Brother, I Confort de Serta (marca 7794), Magnus Spring Air (marca 7790), Tempur Sealy (marca 1380), Luuna, Nooze y Sognare, Dolce Gusto, Nespresso, Lego y Tempur, Accesorios de baño Helvex, Alfombras sobre medida, Persianas, Paquetes de Cocina a precio especial, Pisos (recubrimientos).</p>

                            <ul className="navMenu">
                                <li>
                                    <Link to={`${BASE_PATH}${SUB_DIRECTORY}descuento-primera-compra`}>Descuento Primera Compra</Link>
                                </li>
                                <li>
                                    <Link to={`${BASE_PATH}${SUB_DIRECTORY}carta-cumpleanos`}>Carta Cumpleaños</Link>
                                </li>
                                <li>
                                    <Link to={`${BASE_PATH}${SUB_DIRECTORY}cupon-vip`}>Cupón VIP</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            </main>
            <Footer type="complete"/>
        </>
    )
}